import React from 'react';
import { Image } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { LessonSection } from 'src/pages/LessonPage/children/LessonSection';
import { ContentfulLessonSectionContainer } from 'src/graphql/queries/GetSmLesson';

interface ArticleSectionProps {
  section: ContentfulLessonSectionContainer;
}

const ArticleSection: React.FC<ArticleSectionProps> = ({ section }) => {
  const sectionImage = section.image?.url;
  const backgroundColor = section.backgroundColor;
  const hasNonWhiteBackground = backgroundColor.toLowerCase() !== '#ffffff';

  return (
    <div css={[hasNonWhiteBackground && coloredBackgroundStyles]} style={{ backgroundColor }}>
      <div css={articleSectionOuterContainerStyles}>
        <div css={articleSectionContainerStyles}>
          {sectionImage && (
            <Image src={sectionImage} alt={section.title} style={{ minHeight: '48px', objectFit: 'cover' }} />
          )}
          <LessonSection
            titleContainerStyle={{ margin: `0 0 ${token('space.200')} 0 !important` }}
            key={section.sys.id}
            section={section}
            titleLevel={4}
          />
        </div>
      </div>
    </div>
  );
};

const coloredBackgroundStyles = css({
  paddingTop: token('space.600'),

  [media.below.md]: {
    paddingTop: token('space.300'),
  },
});

const articleSectionOuterContainerStyles = css({
  maxWidth: '1022px',
  margin: '0 auto',
});

const articleSectionContainerStyles = css({
  maxWidth: '702px',
  display: 'flex',
  flexDirection: 'column',
  rowGap: token('space.200'),

  '& [data-testid="accordion-block"]': {
    padding: `${token('space.200')} 0 ${token('space.400')} 0`,

    [media.below.md]: {
      padding: `${token('space.200')} 0 ${token('space.200')} 0`,
    },
  },

  [media.below.md]: {
    maxWidth: '100%',
    padding: `0 ${token('space.300')}`,
  },

  [media.below.sm]: {
    padding: `0 ${token('space.200')} !important`,
  },
});

export default ArticleSection;
